import { render } from "./RatingGraph.vue?vue&type=template&id=b7cc1054&scoped=true"
import script from "./RatingGraph.vue?vue&type=script&lang=js"
export * from "./RatingGraph.vue?vue&type=script&lang=js"

import "./RatingGraph.vue?vue&type=style&index=0&id=b7cc1054&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7cc1054"]])

export default __exports__